import { useWebAudioPlayer, WebAudioSource } from "core/hooks/useWebAudioPlayer/useWebAudioPlayer";
import { AudioPlayerPopupView } from "../AudioPlayerPopupView/AudioPlayerPopupView";
import { useTrackAudioPlayStart } from "../../../hooks/useTrackAudioPlayStart/useTrackAudioPlayStart";
import { AudioPlayerResource } from "../../../enums/types";

type WebAudioPlayerPopupProps = {
  resource: AudioPlayerResource;
  onClose: () => void;
  onDone: () => void;
};

export const WebAudioPlayerPopup = ({ resource, onClose, onDone }: WebAudioPlayerPopupProps) => {
  const player = useWebAudioPlayer();
  const handlePlay = useTrackAudioPlayStart(player.play);

  return (
    <>
      <WebAudioSource src={resource.src} player={player} />
      <AudioPlayerPopupView
        resource={resource}
        duration={player.duration}
        playTime={player.playTime}
        isPlaying={player.isPlaying}
        error={player.error}
        onPlay={handlePlay}
        onPause={player.pause}
        onStop={player.stop}
        onSeekMouseDown={player.onSeekMouseDown}
        onSeekMouseUp={player.onSeekMouseUp}
        onSeekChange={player.onSeekChange}
        onClose={onClose}
        onDone={onDone}
      />
    </>
  );
};
